import $ from "jquery";
import "popper.js"; // Bootstrap requires this // Bundled with legacy JS
import "bootstrap"; // Bundled with legacy JS
//import "fslightbox";
//import "lightbox.js";
// Can import modules as needed
// ex. import 'bootstrap/js/dist/dropdown';
import "./scss/style.scss";

// # ---------------------------------------------------------------
// # Custom Methods...
(function ($) {
	$(function () {
		//console.log("Document Ready");

		// Courses card flip
		$('.course-card').on('click', function (e) {

			// prevent links inside from triggering flip
			if ($(e.target).is('a')) return;

			// close other cards
			// $('.course-card').not(this).removeClass('is-flipped');

			// toggle this one
			$(this).toggleClass('is-flipped');
		});

	});


// For the email_obfuscate shortcode. 
	$(function () {
		$('.obfuscated-email').each(function () {
			const $link = $(this);
			const encodedEmail = $link.data('email');
			const encodedText = $link.data('text');

			if (!encodedEmail || !encodedText) {
				return;
			}

			try {
				const email = atob(encodedEmail).split('').reverse().join('');
				const text = atob(encodedText).split('').reverse().join('');

				// Build the real mailto link.
				$link.attr('href', 'mailto:' + email);

				// Build the visible link text.
				$link.text(text);

				// Remove the encoded data after it has been used.
				$link.removeAttr('data-email data-text');

			} catch (error) {
				console.error('Unable to decode obfuscated email address.', error);
			}
		});
	});


})($);
